(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hooded-towel-size-guide"] && !Shopify.designMode) return;
  try {
    function initialiseMoonessaSizeGuides(scope) {
    scope.querySelectorAll('[data-mns-size-guide]').forEach(function (guide) {
      if (guide.dataset.mnsReady === 'true') return;
      guide.dataset.mnsReady = 'true';
      guide.querySelectorAll('[data-mns-unit]').forEach(function (button) {
        button.addEventListener('click', function () {
          var unit = button.dataset.mnsUnit;
          guide.querySelectorAll('[data-mns-unit]').forEach(function (item) {
            item.setAttribute('aria-pressed', String(item === button));
          });
          guide.querySelectorAll('[data-mns-value]').forEach(function (value) {
            value.textContent = value.dataset[unit];
          });
          guide.querySelectorAll('[data-mns-unit-label]').forEach(function (label) {
            label.textContent = unit;
          });
        });
      });
    });
  }

  initialiseMoonessaSizeGuides(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialiseMoonessaSizeGuides(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["towel-size-guide"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mns-towel-guide]').forEach(function (guide) {
    if (guide.dataset.mnsTowelReady === 'true') return;
    guide.dataset.mnsTowelReady = 'true';

    guide.querySelectorAll('[data-mns-towel-unit]').forEach(function (button) {
      button.addEventListener('click', function () {
        var unit = button.dataset.mnsTowelUnit;

        guide.querySelectorAll('[data-mns-towel-unit]').forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === button));
        });

        guide.querySelectorAll('[data-mns-towel-value]').forEach(function (value) {
          value.textContent = value.dataset[unit];
        });

        guide.querySelectorAll('[data-mns-towel-unit-label]').forEach(function (label) {
          label.textContent = unit;
        });

        guide.querySelectorAll('[data-mns-towel-diagram-value]').forEach(function (value) {
          value.textContent = value.dataset[unit];
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
